import React from 'react';
import { useEffect } from 'react';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import PropTypes from 'prop-types';

import { getTranslation } from 'common/react/utils/translations';
import { FETCH_PREDICTED_DATA } from 'store/modules/brownlow-tracker/player-modal/actions';
import {
    PlayerModalDataSelector,
    PlayerModalPredictedSelector,
    playerModalSelector
} from 'store/modules/brownlow-tracker/player-modal/selectors';

export const PlayerModalVotes = () => {
    const dispatch = useDispatch();
    const playerModalData = useSelector(playerModalSelector);
    // eslint-disable-next-line no-magic-numbers
    const seasonYear = playerModalData.seasonPid.substr(4, 4);
    const data = useSelector(PlayerModalDataSelector);
    const predictedData = useSelector(PlayerModalPredictedSelector);

    const playerVotesData = useMemo(() => {
        return playerModalData.playerId
            ? data?.players?.find(
                  (item) => item.player.playerId === playerModalData.playerId
              )
            : null;
    }, [playerModalData, data]);

    const playerIndex = useMemo(() => {
        if (playerModalData.playerId && data && data.players?.length) {
            const clonedPlayers = [...data.players];
            const sortedPlayers = clonedPlayers.sort(
                (a, b) => b.votes - a.votes
            );
            return (
                sortedPlayers.indexOf(
                    sortedPlayers.find(
                        (item) =>
                            item.player.playerId === playerModalData.playerId
                    )
                ) + 1
            );
        }
        return null;
    }, [playerModalData, data]);

    useEffect(() => {
        // Fetch predicted data
        if (
            playerVotesData?.player &&
            (!predictedData ||
                (predictedData?.players?.length &&
                    !predictedData.players.find(
                        (item) => item.providerId === playerModalData.playerId
                    )))
        ) {
            dispatch(
                FETCH_PREDICTED_DATA.request({
                    season: playerModalData.seasonId,
                    playerName:
                        playerVotesData?.player.givenName +
                        ' ' +
                        playerVotesData?.player.surname
                })
            );
        }
    }, [playerVotesData]);

    return (
        <div className="brownlow-player-modal__votes-container">
            <div className="brownlow-player-modal__current-votes">
                <span className="brownlow-player-modal__label brownlow-player-modal__label--full-width">
                    <span>{seasonYear}</span>
                    {' ' + getTranslation('label.votes')}
                </span>
                <span className="brownlow-player-modal__votes-count">
                    {playerModalData.playerId
                        ? playerVotesData?.votes ?? '-'
                        : ''}
                </span>
                <span className="brownlow-player-modal__votes-position">
                    {playerModalData.playerId &&
                    playerIndex &&
                    playerIndex !== 0
                        ? PULSE.app.common.numberHelper.ordinalSuffix(
                              playerIndex
                          )
                        : ''}
                </span>
            </div>
            <div className="brownlow-player-modal__other-votes">
                <div className="brownlow-player-modal__other-votes-content">
                    <span className="brownlow-player-modal__label">
                        {getTranslation('label.brownlow.tracker.predicted')}
                    </span>
                    <span className="brownlow-player-modal__votes-count--right">
                        {predictedData?.players?.find(
                            (item) =>
                                item.providerId === playerModalData.playerId
                        )?.totalVotes ?? '-'}
                    </span>
                </div>
            </div>
        </div>
    );
};
